import BaseButton from "../../../components/ui/BaseButton";
import BaseWrapper from "../../../components/ui/BaseWrapper";
import { useLocation, useNavigate } from "react-router-dom";

const CreateEditClientAccountHeader = ({ onSave, isLoading, isUpdated }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isEdit = location.pathname.toLowerCase().includes("edit");
  return (
    <div
      className={`border-b border-zinc-300 bg-white w-full sticky top-0 z-10`}
    >
      <BaseWrapper>
        <div className="grid grid-cols-7 py-[7px] items-center">
          <div className="sm:col-span-3 col-span-7">
            <h3 className="font-light">
              {isEdit ? "Edit Client Account" : "Create New Client Account"}
            </h3>
          </div>

          <div className="sm:col-span-4 col-span-7 flex items-center justify-end gap-3">
            <BaseButton
              type="button"
              variant="contained"
              color="primary"
              onClick={() => navigate("/workBoard/clients/account")}
              className="py-[5px]"
            >
              Cancel
            </BaseButton>

            <BaseButton
              loaderSize="24px"
              isLoading={isLoading}
              disabled={isLoading || !isUpdated}
              type="submit"
              variant="contained"
              color="primary"
              onClick={onSave}
              className="py-[5px] "
            >
              {isEdit ? "Update Account" : "Create Account"}
            </BaseButton>
          </div>
        </div>
      </BaseWrapper>
    </div>
  );

};

export default CreateEditClientAccountHeader;
